module.exports = __webpack_public_path__ + "img/partner1.5069f867.png";